import { render, staticRenderFns } from "./FolderTableHeader.vue?vue&type=template&id=2b9d01ae&scoped=true&"
import script from "./FolderTableHeader.vue?vue&type=script&lang=ts&"
export * from "./FolderTableHeader.vue?vue&type=script&lang=ts&"
import style0 from "./FolderTableHeader.vue?vue&type=style&index=0&id=2b9d01ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9d01ae",
  null
  
)

export default component.exports